
@if (isOpen()) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black/70 flex items-center justify-center z-[2000] backdrop-blur-sm animate-fade-in">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-md border border-slate-200 overflow-hidden" (click)="$event.stopPropagation()">
      
      <!-- Header -->
      <div class="bg-slate-50 p-5 border-b border-slate-200 flex justify-between items-center">
        <h2 class="text-lg font-bold text-slate-800 flex items-center gap-2">
            <i class="fa-solid fa-file-export text-emerald-600"></i> ส่งออกข้อมูล (Export Data)
        </h2>
        <button (click)="onClose()" [disabled]="isProcessing()" class="text-slate-400 hover:text-slate-600 transition-colors">
            <i class="fa-solid fa-times text-xl"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="p-6 space-y-4">
        <p class="text-sm text-slate-600 mb-4">กรุณาเลือกช่วงเวลาของข้อมูลผู้ป่วยที่ต้องการส่งออก:</p>

        <!-- Option 1: All Time -->
        <label class="flex items-center p-3 border rounded-lg cursor-pointer transition-all hover:bg-slate-50"
               [class.border-emerald-500]="exportType() === 'ALL'"
               [class.bg-emerald-50]="exportType() === 'ALL'">
            <input type="radio" name="exportType" value="ALL" [checked]="exportType() === 'ALL'" (change)="onTypeChange('ALL')" class="w-4 h-4 text-emerald-600 border-gray-300 focus:ring-emerald-500">
            <div class="ml-3">
                <span class="block text-sm font-bold text-slate-800">ทั้งหมด (All Time)</span>
                <span class="block text-xs text-slate-500">ข้อมูลผู้ป่วยทั้งหมดตั้งแต่เริ่มใช้งาน</span>
            </div>
        </label>

        <!-- Option 2: This Month -->
        <label class="flex items-center p-3 border rounded-lg cursor-pointer transition-all hover:bg-slate-50"
               [class.border-emerald-500]="exportType() === 'MONTH'"
               [class.bg-emerald-50]="exportType() === 'MONTH'">
            <input type="radio" name="exportType" value="MONTH" [checked]="exportType() === 'MONTH'" (change)="onTypeChange('MONTH')" class="w-4 h-4 text-emerald-600 border-gray-300 focus:ring-emerald-500">
            <div class="ml-3">
                <span class="block text-sm font-bold text-slate-800">เดือนนี้ (Current Month)</span>
                <span class="block text-xs text-slate-500">เฉพาะผู้ป่วยที่ลงทะเบียนในเดือนปัจจุบัน</span>
            </div>
        </label>

        <!-- Option 3: Custom -->
        <label class="flex items-center p-3 border rounded-lg cursor-pointer transition-all hover:bg-slate-50"
               [class.border-emerald-500]="exportType() === 'CUSTOM'"
               [class.bg-emerald-50]="exportType() === 'CUSTOM'">
            <input type="radio" name="exportType" value="CUSTOM" [checked]="exportType() === 'CUSTOM'" (change)="onTypeChange('CUSTOM')" class="w-4 h-4 text-emerald-600 border-gray-300 focus:ring-emerald-500">
            <div class="ml-3">
                <span class="block text-sm font-bold text-slate-800">กำหนดเอง (Custom Range)</span>
                <span class="block text-xs text-slate-500">ระบุวันที่เริ่มต้นและสิ้นสุด</span>
            </div>
        </label>

        @if(exportType() === 'CUSTOM') {
            <div class="grid grid-cols-2 gap-3 pl-8 animate-fade-in">
                <div>
                    <label class="block text-xs font-bold text-slate-500 mb-1">จากวันที่</label>
                    <input type="date" [ngModel]="customStart()" (ngModelChange)="customStart.set($event)" class="w-full text-sm border-slate-300 rounded-md focus:ring-emerald-500 focus:border-emerald-500">
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-500 mb-1">ถึงวันที่</label>
                    <input type="date" [ngModel]="customEnd()" (ngModelChange)="customEnd.set($event)" class="w-full text-sm border-slate-300 rounded-md focus:ring-emerald-500 focus:border-emerald-500">
                </div>
            </div>
        }
      </div>

      <!-- Footer -->
      <div class="p-4 bg-slate-50 border-t border-slate-200 flex justify-end gap-3">
        <button (click)="onClose()" [disabled]="isProcessing()" class="px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-700 font-bold hover:bg-slate-50 text-sm transition-colors">ยกเลิก</button>
        <button (click)="onConfirm()" [disabled]="isProcessing()" class="px-6 py-2 bg-emerald-600 text-white rounded-lg font-bold hover:bg-emerald-700 text-sm transition-colors flex items-center gap-2 shadow-sm disabled:opacity-70">
            @if(isProcessing()) {
                <i class="fa-solid fa-spinner animate-spin"></i> กำลังส่งออก...
            } @else {
                <i class="fa-solid fa-download"></i> ยืนยัน (Export)
            }
        </button>
      </div>

    </div>
  </div>
}
